
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/details/[plan_version_id]",
      function () {
        return require("private-next-pages/details/[plan_version_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/details/[plan_version_id]"])
      });
    }
  